<template>
  <div class="space-y-4">
    <div
      class="bg-ontick-graphite-500 space-y-6 rounded px-4 py-6 shadow sm:p-10"
    >
      <!-- <button @click="$emit('goToRegisterCheck')">
        <i v-html="$icons.chevron_left"></i>
      </button> -->
      <h2 class="font-bold sm:text-2xl">
        Insira o código enviado ao email {{ formattedEmail }}
      </h2>
      <form class="space-y-4" autocomplete="off">
        <input autocomplete="false" class="hidden" />
        <ontick-pin-code-input-component v-model="code" />
      </form>
    </div>
    <div class="flex w-full items-center justify-end">
      <transition name="fade">
        <button
          @click="$emit('registered')"
          class="text-ontick-carbon-900 bg-ontick-blue-600 w-full rounded py-2 px-12 text-sm font-semibold shadow filter transition-all hover:brightness-125 sm:w-auto"
        >
          Avançar
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
import ontickPinCodeInputComponent from "../../../shared/components/basic/ontick-pin-code-input.component.vue";
export default {
  components: { ontickPinCodeInputComponent },

  props: {
    emailInput: {
      type: String,
    },
  },

  data() {
    return {
      code: "",
    };
  },

  computed: {
    formattedEmail() {
      let username = this.emailInput.split("@")[0];
      let domain = this.emailInput.split("@")[1];
      return `${username.slice(0, 2)}${"*".repeat(
        username.length - 2
      )}@${domain}`;
    },
  },
};
</script>

<style></style>
